import React, { useMemo, useState } from 'react';
import StepShell from '../../onboarding/StepShell';
import EyeIcon from '../../onboarding/EyeIcon';

const NewPasswordStep = ({ passwords, setPasswords, onSubmit, onBack, submitting, error }) => {
  const [touched, setTouched] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const strongEnough = passwords.password.length >= 8;
  const matches = passwords.password && passwords.password === passwords.confirmPassword;
  const isValid = strongEnough && matches;

  const errorMessage = useMemo(() => {
    if (!touched) return '';
    if (!strongEnough) return 'Password must be at least 8 characters.';
    if (!matches) return 'Passwords do not match.';
    return '';
  }, [touched, strongEnough, matches]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setTouched(true);
    if (!isValid) return;
    onSubmit();
  };

  return (
    <StepShell
      step={3}
      totalSteps={3}
      title="Create a new password"
      subtitle="Make it strong — at least 8 characters"
      onBack={onBack}
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <div className="ob-field">
          <label className="ob-label">New password</label>
          <div className="ob-password-field">
            <input
              type={showPassword ? 'text' : 'password'}
              className="ob-input"
              value={passwords.password}
              onChange={(e) => setPasswords({ ...passwords, password: e.target.value })}
              placeholder="••••••••"
              autoFocus
            />
            <button
              type="button"
              className="ob-eye-toggle"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              <EyeIcon off={showPassword} />
            </button>
          </div>
        </div>

        <div className="ob-field">
          <label className="ob-label">Confirm new password</label>
          <div className="ob-password-field">
            <input
              type={showConfirm ? 'text' : 'password'}
              className="ob-input"
              value={passwords.confirmPassword}
              onChange={(e) => setPasswords({ ...passwords, confirmPassword: e.target.value })}
              placeholder="••••••••"
            />
            <button
              type="button"
              className="ob-eye-toggle"
              onClick={() => setShowConfirm((v) => !v)}
              aria-label={showConfirm ? 'Hide password' : 'Show password'}
            >
              <EyeIcon off={showConfirm} />
            </button>
          </div>
        </div>

        {errorMessage && <p className="ob-error-text">{errorMessage}</p>}
        {error && <p className="ob-error-text">{error}</p>}

        <div className="ob-spacer" />

        <button type="submit" className="ob-btn-primary" disabled={!isValid || submitting}>
          {submitting ? 'Saving…' : 'Reset password'}
        </button>
      </form>
    </StepShell>
  );
};

export default NewPasswordStep;
